import styled from "styled-components";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const UserDetailsWrapperDefaultBox = styled.div`
    /* .user-details-box-wrapper */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    ${CssRule.For.mobile.build()} &{
        flex-direction: row;

        &:after {
            content: "";
            display: block;
            width: 15px;
            height: 15px;
            margin-left: auto;
            background-image: url("${({theme}) => theme.images.spriteSheet.toString()}");
            background-position: -749px -654px;
        }
    }

    ${CssRule.For.RTL.mobile.build()} &{
        &:after {
            transform: scaleX(-1);
        }
    }

`;

/* 777 */
const UserDetailsWrapperCasino777Box = styled(UserDetailsWrapperDefaultBox)`
    ${CssRule.For.mobile.build()} &{
        padding: 1rem;
        background: ${({theme}) => theme.colors.componentBackground};
        border-radius: 5px;
    }
`;

export const UserDetailsWrapperBox = styledByTheme(UserDetailsWrapperDefaultBox).forCasino777(UserDetailsWrapperCasino777Box).apply();
